module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "install wrap",
    class: (_vm.gotFluide) ? '' : 'nofluide',
    attrs: {
      "to": {
        name: 'installation',
        params: {
          id: this.$route.params.id,
          idInst: _vm.installation.id
        }
      }
    }
  }, [_c('p', {
    staticClass: "identification"
  }, [_c('strong', [_vm._v(_vm._s(_vm.installation.nom))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.installation.marque && _vm.installation.modele) ? _c('span', {
    staticClass: "marque-modele"
  }, [_vm._v("\n            " + _vm._s(_vm.installation.marque) + " - "), _c('b', [_vm._v(_vm._s(_vm.installation.modele))])]) : _vm._e()]), _vm._v(" "), (_vm.gotFluide) ? _c('div', {
    staticClass: "infos-sup"
  }, [_c('div', {
    staticClass: "btn refrigerant"
  }, [_c('i', {
    staticClass: "icon-fluid"
  }), _vm._v("\n            " + _vm._s(_vm.installation.fluide.nom) + "\n        ")]), _vm._v(" "), (_vm.installation.i_tag !== null) ? _c('div', {
    staticClass: "otagInstall"
  }, [_c('i', {
    staticClass: "icon-otag"
  }), _vm._v("\n            " + _vm._s(_vm.installation.i_tag) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "charge-totale"
  }, [_vm._v("\n            CHARGE TOTALE "), _c('b', [_vm._v(_vm._s(_vm.installation.charge) + " kg")])])]) : _c('div', [(_vm.installation.i_tag !== null) ? _c('div', {
    staticClass: "otagInstall"
  }, [_c('i', {
    staticClass: "icon-otag"
  }), _vm._v("\n            " + _vm._s(_vm.installation.i_tag) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "icon-barre"
  }, _vm._l((_vm.alertes), function(alerte, index) {
    return _c('div', {
      key: index,
      staticClass: "tooltip-container",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggleTooltip(index)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-exclamation-triangle alert-icon",
      style: ({
        color: alerte.color
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "inst-tooltip",
      class: {
        show: _vm.openedTooltip === index
      },
      domProps: {
        "innerHTML": _vm._s(alerte.tooltip)
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1583f213","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/installation/InstallationItem.vue
// module id = 740
// module chunks = 0